<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, nextTick, getCurrentInstance } from "vue";
import CommonBaseButtons from "@/components/common/BaseButtons.vue";
import CommonVTimeLineDay from "@/components/common/VTimeLineDay.vue";
import { getSiteData } from "@/NavigationHelper";
import {
  mountedBase,
  BaseSetup,
} from "@/DataLoaderStatic";
import { goBack } from "@/NavigationHelper";
const emit = defineEmits(["back"]);
const siteData = getSiteData();
let myHeight = ref<number>(900);
let day = ref<Date>(new Date(siteData?.zeitbereich.von)) ?? new Date();
let titel: string = siteData?.title ?? "";

function onRefresh() {
  const instance = getCurrentInstance();
  if (instance) {
    (instance.proxy?.$refs.timelines as any).onRefresh();
  }
}
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  await mountedBase(uiData, pageParams);
  uiData.showLoading = false;
  uiData.initialized = true;
  myHeight.value = window.innerHeight - 100;
});
</script>
<template>
  <v-card
    :loading="uiData.showLoading"
    class="pa-0"
    max-width="450px"
    :max-height="myHeight - 10"
  >
    <CommonVTimeLineDay
      query="WebStempelungenSoftTerm"
      :contentHeight="myHeight - 120"
      ref="timeline"
      :showError="true"
      :showTagessaldo="false"
      :showNacherfassung="true"
      :showProjektstunden="false"
      :showReisekosten="false"
      queryEdit="Web_TimeLineStempelungen"
      :day="day"
      :showClose="false"
      class="pa-0"
      :aic="pageParams.aic"
      :showName="false"
    />

    <v-card-actions>
      <v-spacer></v-spacer>
      <CommonBaseButtons
        :createVisible="false"
        :refreshVisible="false"
        :deleteVisible="false"
        :saveVisible="false"
        @back="goBack()"
      ></CommonBaseButtons>
    </v-card-actions>
  </v-card>
</template>
<style scoped></style>
